module.exports = __webpack_public_path__ + "img/coronagirlfr.a659e2ed.svg";